var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 15.68,
    width: 18,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.215 0A2.215 2.215 0 104.43 2.215 2.217 2.217 0 002.215 0zM2.215 5.625A2.215 2.215 0 104.43 7.84a2.217 2.217 0 00-2.215-2.215zM2.215 11.25a2.215 2.215 0 102.215 2.215 2.217 2.217 0 00-2.215-2.215zM16.348.563h-9.07a1.652 1.652 0 000 3.3h9.07a1.652 1.652 0 000-3.3zM16.348 6.188h-9.07a1.652 1.652 0 000 3.3h9.07a1.652 1.652 0 000-3.3zM16.348 11.813h-9.07a1.652 1.652 0 000 3.3h9.07a1.652 1.652 0 000-3.3z"
  }))));
}
export default __webpack_public_path__ + "media/icons/icn_folder-29317219.svg";
export { SvgIcnFolder as ReactComponent };